// @ts-nocheck
import React from 'react'
import { DropdownTitle } from '../../../generic'
import {
  EmarStockAlertField,
  EmarStockUnitsField,
  EmarCurrentStockField,
} from '../fields'

interface EmarStockFieldsSectionProps {
  editState: boolean
  // Add other props as needed
}

const EmarStockFieldsSection: React.FC<EmarStockFieldsSectionProps> = (
  props
) => {
  return (
    <div style={styles.container}>
      <DropdownTitle isOpen title="Stock">
        <EmarStockUnitsField {...props} />
        <EmarStockAlertField {...props} />
        {!props.editState && <EmarCurrentStockField {...props} />}
      </DropdownTitle>
    </div>
  )
}

const styles = {
  container: {
    width: '100%',
  },
}

export default EmarStockFieldsSection
